import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  LinearProgress,
  OutlinedInput,
  Radio,
  RadioGroup,
  Alert,
  DialogContentText,
} from "@mui/material"
import { Send } from "@mui/icons-material"
import React, { useEffect, useState } from "react"
import NumberFormat from "react-number-format"
import { Box } from "@mui/system"
import { resetExecutorFlag, sendSmsPayment } from "store/actions"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { TextMaskPhone } from "./TextMask"
const DialogOwnerBank = props => {
  const { loading, payProfit, classSet } = props

  const [openDialog, setOpenDialog] = useState(false)
  const [amount, setAmount] = useState(1000000)
  const [mobile, setMobile] = useState("")
  const [selectBank, setSelectBank] = useState(1)
  const [isValid, setIsValid] = useState(false)

  const handleClickOpen = () => {
    setOpenDialog(true)
  }

  const handleClose = () => {
    setOpenDialog(false)
  }
  function sendToOwner() {
    const { onSendSmsPayment } = props
    if (selectBank === 1) {
      onSendSmsPayment({ mobile, amount: +amount })
    }
  }

  useEffect(() => {
    setTimeout(() => {
      props.onResetExecutorFlag()
    }, 3000)
  }, [props.success, props.error])

  return (
    <div className={props.classSet}>
      <Button
      fullWidth
        className="btn pb-0 pt-0 d-flex gap-5 bg-white btn-outline-primary rounded-3"
        onClick={handleClickOpen}
      >
        <span className="fs-5 text-primary">شارژ توسط مالک</span>
        <i className="mdi mdi-card-plus-outline text-primary fs-4  info  " />
      </Button>

      <Dialog open={openDialog} onClose={handleClose}>
        <DialogContent>
          {loading && <LinearProgress />}
          <DialogContentText>شارژ توسط مالک</DialogContentText>
          <DialogContentText>به دلیل ارسال مبلغ بیشتر از تعرفه توسط مجری غیر فعال شده است</DialogContentText>
          <DialogContentText>تا انجام بازرسی و تصمیم گیری در این مورد به صورت موقت غیر فعال می باشد</DialogContentText>
{/*          <Grid item xs={12}>
            {props.error ? <Alert severity="error">{props.error}</Alert> : null}
            {props.success ? (
              <Alert severity="success">{props.success}</Alert>
            ) : null}
          </Grid>
          <Box
            sx={{
              backgroundColor: "#fff",
              margin: 2,
              paddingInline: 2,
              borderRadius: 2,
              textAlign: "center",
              height: "100%"
            }}
          >
            <Grid container justifyContent={"center"} alignItems={"center"}>
              <Grid item xs={12}>
                <RadioGroup
                  name="selectBankEnum"
                  defaultValue={selectBank ? selectBank : 1}
                  onChange={e => setSelectBank(e.target.value)}
                >
                  <Grid container className="px-2">
                    <Grid item>
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="بانک ملی"
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              </Grid>
              <Grid item xs={12}>
                <Grid item>
                  <FormControl dir="ltr">
                    <InputLabel htmlFor="landlordPhoneNumber-input">
                      شماره موبایل مالک
                    </InputLabel>

                    <OutlinedInput
                      type="text"
                      required
                      size="small"
                      label="شماره موبایل مالک"
                      value={mobile}
                      onChange={e => {
                        setMobile(e.target.value)
                        e.target.value.length !== 11
                          ? setIsValid(false)
                          : setIsValid(true)
                      }}
                      name="landlordPhoneNumber"
                      id="landlordPhoneNumber-input"
                      inputComponent={TextMaskPhone}
                    />
                    <FormHelperText>نمونه:1234****09</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item>
                  <NumberFormat
                    className="MuiOutlinedInput-input MuiInputBase-input MuiInputBase-inputSizeSmall"
                    value={amount}
                    onValueChange={values => {
                      const { value } = values
                      setAmount(value)
                    }}
                    thousandSeparator={true}
                  />
                  ریال
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Button
            disabled={!isValid}
            fullWidth={true}
            size="small"
            variant="outlined"
            startIcon={<Send />}
            onClick={sendToOwner}
          >
            ارسال برای مالک جهت پرداخت
          </Button>*/}
        </DialogContent>
      </Dialog>
    </div>
  )
}

const mapStateToProps = ({ Executors }) => ({
  error: Executors.error,
  success: Executors.success,
  loading: Executors.loading,
})

const mapDispatchToProps = dispatch => ({
  onSendSmsPayment: events => dispatch(sendSmsPayment(events)),
  onResetExecutorFlag: () => dispatch(resetExecutorFlag()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(DialogOwnerBank))
